import { render, staticRenderFns } from "./RFPDetailsBOQFile.vue?vue&type=template&id=458a56ac"
import script from "./RFPDetailsBOQFile.vue?vue&type=script&lang=js"
export * from "./RFPDetailsBOQFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports